let $body = document.body
let $header = document.getElementById('header')

export function getOffset ($el, align = 'top') {
  let bodyRect = $body.getBoundingClientRect()
  let elemRect = $el.getBoundingClientRect()
  let offset = elemRect.top - bodyRect.top

  if (align === 'top') {
    offset = offset - 30
  } else if (align === 'middle') {
    offset = offset - window.innerHeight / 2
  }

  if ($header) {
    offset = offset - $header.getBoundingClientRect().height
  }

  return offset
}

export function scrollToPosition (y, smooth = true) {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({
      top: y,
      left: 0,
      behavior: smooth ? 'smooth' : 'auto'
    })
  } else {
    window.scrollTo(0, y)
  }
}

export function scrollToElement ($el, smooth = true, align = 'top') {
  scrollToPosition(getOffset($el, align), smooth)
}

export function isScrolling () {
  let top = window.pageYOffset || document.documentElement.scrollTop
  return top > 0
}


// WEBPACK FOOTER //
// ./src/js/utils.js